import type {Editor} from 'grapesjs';
import type {EmailMakerActions, EmailMakerContextProps, EmailMakerImmutableStore, EmailMakerSaveErrorState} from '@EmailMakerReact/email-maker-react.types';
import type {EditorViewport} from '@EmailMakerReact/email-maker-react.types';

export const PUBLISH_HOVER_ANIMATION_CLASS = 'publish-icon-hover-animation';

export const ICON_PUBLISH_ARROW = 'icon-publish-arrow';

export interface NavActionsParams {
  isEditorLoading: boolean;
  editorViewport: EditorViewport;
  editor: Editor | null;
  actions: EmailMakerActions;
  canUndo: boolean;
  canRedo: boolean;
  saveError: EmailMakerSaveErrorState | null;
}

export interface NavByModeParams {
  editor: EmailMakerContextProps['editor'];
  actions: EmailMakerContextProps['actions'];
  state: EmailMakerContextProps['state'];
  store: EmailMakerImmutableStore;
  canUndo: boolean;
  canRedo: boolean;
}
